import getEnvConfig from './getEnvConfig';
import { COST_ENV_CONFIG_KEYS } from '../consts';

export default (env, region, projectId, id) => `${getEnvConfig(
  env,
  region,
  COST_ENV_CONFIG_KEYS.COST_FE
)}/projects/${projectId}/changeorders/pco?preview=${id}`